const config = {
    // API_BASE_URL: 'https://localhost:8000',
    API_BASE_URL: 'https://api.akygacomponents.com:8443',
    // API_BASE_URL: 'https://localhost:8443'
    // API_BASE_URL: 'http://aba.akygacomponents.com:8000'
    
    // CMS Configuration
    CMS_BASE_URL: process.env.REACT_APP_CMS_BASE_URL || 'https://cms.akygacomponents.com',
};

export default config;